import { render, staticRenderFns } from "./AddCpvsToTenderModal.vue?vue&type=template&id=749651a1&scoped=true"
import script from "./AddCpvsToTenderModal.vue?vue&type=script&lang=js"
export * from "./AddCpvsToTenderModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749651a1",
  null
  
)

export default component.exports